"use strict";var p=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var e=(c,n,a,i)=>{for(var t=i>1?void 0:i?u(n,a):n,l=c.length-1,h;l>=0;l--)(h=c[l])&&(t=(i?h(n,a,t):h(t))||t);return i&&t&&p(n,a,t),t};import{baseStyles as o,CiscoUElement as b,html as r}from"@cisco-u/base";import{property as s,query as y}from"@cisco-u/base/src/decorators.js";import{when as d}from"@cisco-u/base/src/directives.js";import f from"./toggle.css.js";export class Toggle extends b{constructor(){super(...arguments);this.checked=!1;this.readonly=!1;this.dark=!1;this.disabled=!1}static get styles(){return[o,f]}render(){return r`
      <div class="switch-container">
        <label
          class="switch"
          aria-label=${this.label}
          .disabled=${this.disabled}
        >
          ${d(this.required,()=>r`<input
              name="input"
              tabindex="0"
              id="input"
              type="checkbox"
              aria-required=${this.required}
              .checked=${this.checked}
              .disabled=${this.disabled}
              @keypress=${this._handleChange}
              @change=${this._handleChange}
            />`,()=>r`<input
                name="input"
                tabindex="0"
                id="input"
                type="checkbox"
                .checked=${this.checked}
                .disabled=${this.disabled}
                @keypress=${this._handleChange}
                @change=${this._handleChange}
              />`)}
          <span class="slider round"></span>
        </label>
        ${d(this.accessible,()=>r`<label for="input" class="text"
              >${this.checked&&"On"||"Off"}</label
            >`)}
      </div>
    `}_handleChange(a){switch(a.type){case"keypress":if(a.key!="Enter")return;this.inputElement.checked=!this.inputElement.checked;return;case"change":if(this.readonly){this.inputElement.checked=this.checked;return}this.checked=this.inputElement.checked;const i=this.checked,t=new CustomEvent("toggle",{detail:{checked:i},bubbles:!0,cancelable:!0,composed:!0});this.dispatchEvent(t)||(this.checked=!this.inputElement.checked,this.inputElement.checked=this.checked);return;default:return}}}e([y("#input")],Toggle.prototype,"inputElement",2),e([s({type:Boolean,reflect:!0})],Toggle.prototype,"checked",2),e([s({type:Boolean,reflect:!0})],Toggle.prototype,"readonly",2),e([s({type:Boolean,reflect:!0})],Toggle.prototype,"dark",2),e([s({type:Boolean,reflect:!0})],Toggle.prototype,"small",2),e([s({type:Boolean,reflect:!0})],Toggle.prototype,"accessible",2),e([s({type:Boolean,reflect:!0})],Toggle.prototype,"required",2),e([s({type:Boolean,reflect:!0})],Toggle.prototype,"disabled",2),e([s({type:String,reflect:!0})],Toggle.prototype,"label",2);
//# sourceMappingURL=Toggle.js.map
